export default {
	currencies: {
		USD: "USD",
		UZS: "UZS",
		EUR: "EUR",
		GBP: "GBP",
		RUB: "RUB",
		CHF: "CHF"
	},
	langs: {
		ru: {
			title: "Русский",
			flag: "ru"
		},
		en: {
			title: "English",
			flag: "us"
		},
		uz: {
			title: "Ўзбекча",
			flag: "uz"
		}
	},
	fileExtensions: {
		PDF: "PDF",
		XLS: "XLS",
		DOC: "DOC",
		TXT: "TXT"
	},
	errors: {
		error: "Ошибка соединения",
		errorTitle: "Ошибка",
		noMatches: 'Совпадений не найдено'
	},
	login: {
		viaDigitalSign: {
			comeBack: 'Вернуться назад',
			enterPassword: 'Введите пароль от сертификата ЭЦП',
			selectCompany: 'Выберите организацию',
			notConnected: 'Модуль УЦ ЭЦП не подключен',
			setupModule: 'Чтобы добавить организацию, нужно установить модуль',
			setup: 'Установить',
			becomeClient: 'Стать клиентом банка',
			insertKey: 'Вставьте ЭЦП ключ',
			keyNotFound: 'ЭЦП ключ не обнаружен. Вставьте ЭЦП ключ в USB-порт. Если у вас нет ЭЦП ключа, обратитесь в ближайший филиал Банка для его получения.',
			keyTerm: 'Срок действия ЭЦП',
			left: 'осталось',
			enterSmsCode: 'Введите код с СМС',
			sessionFinished: 'Сессия закончилось',
			sessionExpiredDetails: 'Вы {0} минут не проявляли активность сессия прервана в целях безопасности. Вы можете заново авторизоваться',
			reSignIn: 'Заново войти',
			backToCompanyList: 'Вернуться к списку организаций',
			yourAccount: 'Вашей учетной записи',
			quickAccess: 'Настройка быстрого доступа',
			enableSms: 'Включение СМС-кода для подтверждения входа',
			disableSms: 'Выключение СМС-кода для подтверждения входа',
			confirmationSms: 'СМС-код для подтверждения входа',
			smsDisablingDetails: 'При отключении функции, не нужно подтверждать вход одноразовым СМС-кодом',
			day: 'день',
			days: 'дня',
			moreDays: 'дней',
			selectOS: 'Выберите операционную систему',
			setupModuleOS: 'Установите УЦ ЭЦП модуль \nна ваш компьютер',
			WINDOWS: 'Windows',
			MAC_OS: 'macOS',
			I_KEY: 'iKey',
			E_PASS: 'ePass',
			selectKeyType: 'Выберите тип ключа',
			howSetup: 'Как установить',
			becomeClientInfin: 'Стать клиентом InfinBusiness',
			growBusiness: 'Развивайте бизнес вместе с нами',
			becomeCustomer: 'Стать клиентом',
			setupToComputer: 'Как установить модуль \nУЦ ЭЦП на ваш компьютер',
			setupToOSByKeyType: 'Как установить УЦ ЭЦП модуль на {0} \n(тип ключа {1})',
			downloadArchive: 'Скачайте архив',
			downloadArchiveDescription: 'Сначала вам необходимо скачать архив, Далее необходимо распаковать архив с помощью архиватора. В архиве находится два файла: IKEY.exe и Isigner.exe.',
			setupIkeyDriver: 'Далее необходимо установить IKEY драйвер',
			setupIkeyDriverDescription: 'Его необходимо установить, для того, чтобы ваш компьютер смог увидеть ключ.',
			setupProcess: 'Процесс установки',
			setupProcessDescription: '<ul class="simple-list"><li>В процессе установки вам необходимо принять лицензию драйвера, нажать “Да”</li><li>Также во время установки появится модальное окно, которое попросит вас вставить флешку-ключ в USB порт для того, чтобы определить совместимость ключа с драйвером. После того, как вставите ключ, программа дальше продолжит установку</li><li>После завершения загрузки, нажмите на кнопку “Finish”</li></ul>',
			execIsigner: 'Далее нужно установить Isigner',
			execIsignerProblem: 'Далее нужно установить Isigner',
			execIsignerProblemDescription: 'Если у вас не удаётся установить программу то сначала нажмите правой кнопкой мыши на файл и в меню выберите команду «Свойства», затем поставить флажек «Разблокировать» и нажать «ОК» как показано на скриншоте.<br><br>После можно попробовать еще раз установить (если не получится то нажмите правой кнопкой мыши на файл и в меню выберите команду «Запуск от имени администратора».)',
			openSetuper: 'При открытии установщика нажмите “Keyingi”',
			openSetuperDescription: 'Также в открывшемся окне установки, можете кликнуть на флажок если хотите чтобы программа была расположена на рабочем столе ваше компьютера.',
			clickToSetup: 'Затем нажмите на кнопку “O’rnatish”',
			clickToReady: 'Затем нажмите на кнопку “Tayyor”',
			clickToReadyDescription: 'Также можно нажать на флажок, чтобы сразу запустить прогрумму.',
			setupCompleted: 'На этом процесс установки будет завершен',
			setupCompletedDescription: 'Если вы выполнили все пункты, можете вернуться на экран входа и авторизоваться в вашу организацию',
		},
		sessionExpirationNotification: 'Через {remainingTime} сессия прервется. Выполните любое действие, чтобы сессия не прервалась',
		confirmSmsCancellation: "Вы действительно хотите отменить ввод смс?",
		resendSms: "Отправленное смс устарело, для продолжения авторизации необходимо получить новое",
		authorization: "Вход в интернет-банк",
		login: "Логин",
		password: "Пароль",
		error: "Обязательное поле",
		errorPassword: "Должно содержать строчный символ, прописные буквы и число.",
		loginOpen: "Войти",
		forgetPassword: "Забыли пароль?",
		howRegister: "Как стать клиентом банка?",
		banner: {
			title: "Ваш личный <br/> мобильный банк!",
			text: "Все услуги теперь под рукой",
			btnApp: "Скачать приложение",
			btnBrowser: "Продолжить через браузер",
			btnUnavailable: 'К сожалению, веб версия "Infinbusiness" доступна только через браузер компьютера или ноутбука.',
		},
		help: {
			title: "Уважаемый клиент!",
			text: "Для входа Вам необходимо обратиться в офис Вашего филиала банка и пройти процесс регистрации. <br/>Необходимые документы для регистрации: <br/>1. Документ, удостоверяющий личность пользователя; <br/>2. Оригинал письма-доверенности организации для доступа в мобильное приложение (см. ниже).",
			download: "Скачать форму",
			close: "Понятно"
		},
		passwordReset: {
			title: "Уважаемый клиент!",
			text: "Для восстановления пароля необходимо обратиться в отделение Банка с паспортом",
			close: "Понятно"
		},
		smsCode: {
			title: "Пожалуйста, <br/> введите код с СМС",
			repeat: "Отправить код снова"
		}
	},
	headerAuth: {
		phone: "Call center для бизнеса",
		telegram: "Телеграм бот",
		department: "Отделения"
	},
	howRegister: {
		headerTitle: "Как стать клиентом банка",
		header: "Стать клиентом банка",
		steps: {
			title: "Три шага, и вы клиент банка!",
			step1: "Проведение личной встречи представителя банка с руководством Компании",
			step2: "Предоставление полного пакета документов для открытия банковского счета",
			step3: "Открытие счёта"
		},
		btn: "Подробнее",
		urlBranch: "https://www.infinbank.com/ru/branches/2/",
		department: {
			title: "Отделения банка",
			text: "Постройте маршрут до банка"
		},
		doc: {
			title: "Документы",
			text: "Необходимые для регистрации бизнеса"
		},
		tariffs: {
			title: "Тарифы",
			text: "Ознакомьтесь с доступными тарифами"
		},
		footer: {
			title: "Контакты",
			phone: "Связаться с Банком можно по телефону",
			email: "По эл. почте:",
			text: "Посетите филиал в оговоренное время, чтобы вместе со специалистом банка открыть счет."
		}
	},
	tariffs: {
		header: "Тарифы",
		btnAllDownload: "Скачать все тарифы",
		btnAllView: "Все тарифы",
		currentTariff: "Текущий тариф:",
		description: "Стоимость пакета",
		month: "в месяц",
		cost: "Бесплатно",
		commission: "без комиссии",
		download: "Скачать",
		titleOther: "Доступные тарифы",
		debit: "Дебетовые обороты",
		foreignCurrency: "Платежи в иностранной валюте",
		nationalCurrency: "Операции в национальной валюте",
		from: "от",
		before: "до"
	},
	doc: {
		header: "Документы",
		title: "Документы, необходимые для открытия банковского счета",
		btnAllDownload: "Скачать все документы",
		download: "Скачать"
	},
	munis: {
		insufficientFunds: "Недостаточно средств",
		selectCategory: 'Выберите категорию',
		operDayClosed: 'Идет процесс закрытия операционного дня',
		operationsDisabled: 'Операции временно недоступны',
		check: 'Проверить',
		btnSendToBank: 'Подписать и отправить',
		alreadyPaid: 'Сумма квитанции по указанному номеру уплачена',
		paymentInfo: 'Данные о платеже',
		continue:'Продолжить',
		searchText: 'Название категории или услуги',
		nothingFound: 'Ничего не найдено',
		maxAmountError: 'Сумма не должна превышать {0} UZS'
	},
	register: {
		registryOperationsText: 'Реестровые операции',
		dndFileTitle: 'Выберите или перетащите заполненную реестровую операцию',
		fileFormat: 'Формат файла excel (.xls, .xlsx)',
		selectFile: 'Выбрать файл',
		rules: 'Правила заполнения полей',
		downloadTemplate: 'Скачать шаблон для заполнения',
		excelFile: 'Excel Файл',
		operDayClosed: 'Операцию временно нельзя совершить. Идет процесс закрытия операционного дня',
		formatFileError: 'Формат файла должен быть .xls, .xlsx',
		creation: 'Создание реестровой операции',
		editing: 'Редактирование реестровой операции',
		uploadedFile: 'Загруженный файл',
		changeFile: 'Заменить файл',
		fileDownload: 'Скачивание файла',
		amountOfOperations: 'Количество платежных поручений',
		totalAmount: 'Общая сумма',
		debitAccount: 'Счет списания',
		errorModalTitle: 'Не удалось загрузить реестровую операцию',
		errorMessageTitle: 'Проверьте правильность заполнения строк:',
		errorCheckTableLines: 'Проверьте правильность заполнения таблицы.',
		helpText: 'Рекомендуем посмотреть ',
		helpLink: 'Правила заполнения полей',
		selectAccount: 'Выберите счет списания',
		btnEnter: 'Ввести',
		btnApprove: 'Отправить директору',
		btnSendToBank: 'Подписать и отправить',
		fileChanged: 'Файл заменен',
		registerPayment: 'платежное поручение',
		registerPayments: 'платежных поручений',
		twoRegisterPayments: 'платежных поручения',
		downloadFile: 'Скачать файл',
		operationStatus: 'Статус операции',
		reasonPaymentRefund: 'Причина возврата платежа:',
		contactOurSupportTeam: 'Если у вас есть вопросы или требуется дополнительная информация, свяжитесь с нашей службой поддержки.',
	},
	home: {
		questionnaire: "Анкета №",
		createTitlePayment: "Создать платёжное поручение",
		createNewTitlePayment: "Создать подобное платежное поручение",
		addFavoriteBills: "Добавить на главную",
		company: "OOO",
		titleBills: "Счета компании",
		textBills: "Показать все",
		nameAccount: "Транзитный счет",
		notification: {
			title: "Уведомление",
			text: "Вам пришло уведомление, пожалуйста нажмите, чтобы ознакомиться с текстом",
			emptyText: "У вас нет уведомлений",
			openText: "Открыть уведомление"
		},
		tabsList: {
			titlePayment: "Платежное поручение",
			recent: "Недавние",
			templates: "Шаблоны",
			btnRecent: "Показать больше"
		},
		statusPayment: {
			title: "Статусы платежных поручений",
			inbox: "Входящие",
			outgoing: "Исходящие платежи и заявки",
			approval: "На утверждение",
			revision: "Отправленные на доработку",
			draft: "Черновики"
		},
		offers: "Предложения для вас",
		payment: {
			title1: "Платежное поручение",
			title2: "Анор",
			title3: "Поручение в бюджет",
			title4: "Пополнение пластиковых карт",
			title5: "Поручение в казначейство",
			title6: "Зарплатная ведомость",
			munis: 'МУНИС',
			register: 'Реестровая операция',
			loanRepayment: 'Погашение кредита',
			anor: 'АНОР'
		},
		organization: "Выбор организации",
		branch: "Выберите филиал",
		favoriteBills: {
			header: "Избранные счета",
			block1: "Выбрано:",
			block2: "Остальное",
			titleBlockSelect: 'Избранные'
		},
		modalPassword: {
			text: "Срок действия Вашего пароля истечет через (5 дней/4/3/2 дня/ 1 день). В целях безопасности, во избежание несанкционированного доступа к Вашей учетной записи просим Вас сменить текущий пароль заранее.",
			textChange: "В целях безопасности, во избежание несанкционированного доступа к Вашей учетной записи, срок действия Вашего пароля истек. Просим Вас сменить Ваш текущий пароль.",
			btnChange: "Сменить сейчас",
			btnLater: "Сменить позже"
		}
	},
	header: {
		main: "Главная",
		services: "Сервисы",
		chat: "Чат",
		history: "История",
		electCommerce: "Электронная коммерция",
		mfo: "МФО:",
		in: "в"
	},
	menu: {
		closedOperDay: "Операционный день закрыт",
		operDay: "Операционный день:",
		terms: "Тарифы",
		employees: "Сотрудники",
		setting: "Настройки",
		branch: "Отделения",
		current: "Курсы валют",
		contract: "Контрагенты",
		support: "Поддержка",
		signOut: "Выйти из аккаунта",
		appVersion: "Версия"
	},
	breadcrumb: {
		title: "Главная"
	},
	companyAccounts: {
		cards: {
			title: "Карты",
			btn: "Заказать карту",
			info: {
				title: "Информация о карте",
				number: "Номер карты",
				balanceCards: "Баланс карты",
				nameCard: "Дебетовая карта",
				tabInfo: "О карте"
			},
			statuses: {
				active: "Карта активна",
				lock: "Карта заблокирована",
				blockClient: "Заблокировано клиентом",
				pinLimit: "Требуется установка ПИН кода",
				pin: "Лимит ввода ПИН исчерпан",
				blockBank: "Заблокировано банком"
			},
			history: {
				btnFirst: 'Поступления',
				btnSecond: 'Расход',
				print: 'Распечатать',
				translate: 'Переведен',
				point: 'Пункт платежа',
				servicePoint: 'Пункт обслуживания',
				terminal: 'Терминал',
				date: 'Дата и время оплаты',
				amountCancel: 'Сумма списания',
				numberTransaction: 'Номер транзакции'
			}
		},
		deposits: {
			title: "Депозиты",
			info: {
				title: "Информация о депозите"
			},
			titleByType: {
				SAVINGS_DEPOSIT: 'Сберегательный депозит',
				TERM_DEPOSIT: 'Срочный депозит',
			}
		},
		bills: {
			cardBlocked: "Счет заблокирован",
			blocked: "Заблокирован",
			title: "Счета",
			info: {
				title: "Информация о счете",
				text: "Счет",
				number: "Номер счета",
				mfo: "МФО",
				date: "Дата открытия",
				dateClose: "Дата закрытия",
				status: "Состояние",
				openBal: "Входящий остаток",
				debit: "Дебит",
				credit: "Кредит",
				closBal: "Исходящий остаток",
				history: "История",
				approved: "Утвержден",
				opened: "Открыт",
				closed: "Закрыт",
				balanceAccount: "Баланс счета",
				tabInfo: "О счёте"
			}
		},
		loans: {
			title: "Кредиты",
			header: "Сумма кредита",
			remaining: "Осталось",
			payment: "платежей",
			titleMain: "Основная сумма:",
			titleAccrued: "Начисленные %:",
			noPaid: "Не оплачено",
			paid: "Оплачено",
			creditPurpose: "Цель кредита",
			loanAccounts: "Ссудные счета",
			nextPay: "След. платеж:",
			overduePay: "Просрочен платёж:",
			repay: "Погасить",
			schedule: "График",
			creditDetails: "Детали по кредиту",
			principalDebt: "Остаток основного долга",
			accrued: "Начисленные проценты",
			totalCredit: "Общая сумма кредита",
			contractTerms: "Условия договора",
			contractNumber: "Номер договора",
			contractDate: "Дата договора",
			interestRate: "Процентная ставка",
			contractEffect: "Срок действия договора до",
			loanAccount: "Номер ссудного счета",
			nextPayment: "Следующий платеж",
			tabInfo: "О кредите",
			minAmount: 'Минимальная сумма кредита (лимита) {0} UZS',
			maxAmount: 'Максимальная сумма кредита (лимита) {0} UZS',
			history: {
				btnFirst: 'Погашение',
				btnSecond: 'Выдача',
				title: 'История использования кредита',
				emptyBlock: {
					title: 'За выбранный период нет операций',
					text: 'Для отображения операций измените период'
				}
			}
		},
		replenish: {
			header: "Пополнить",
			title1: "Откуда",
			title2: "Куда",
			inputLabel: "Сумма перевода",
			inputText: "Комиссия:",
			card: 'Пополнение карты'
		},
		transfer: "Перевести",
		modal: {
			titleUnlockCard: "Разблокировать карту",
			textUnlockCard: "Вы уверены, что хотите разблокировать карту?",
			titleLockCard: "Заблокировать карту",
			textLockCard: "Вы уверены, что хотите заблокировать карту?"
		},
		cancel: "Отменить",
		accept: "Принять",
		nameAccount: "Наименование счета"
	},
	createSumPayment: {
		loanRepaymentDetail: 'Погашение кредита анкета № {0}',
		nameBank: "Наименование банка",
		header: "Новый платеж",
		treasuryMinitstry: 'Казначейство Министерства финансов Республики Узбекистан',
		aside: {
			title: "Информация о платеже",
			textField1: "Тип поручения",
			textField2: "Документ №",
			textField3: "Дата платежа",
			btn: "Выбрать из шаблонов"
		},
		send: {
			title: "Отправитель",
			textField1: "Наименование отправителя",
			receiverName: "Наименование получателя",
			textField2: "Номер счета отправителя",
			senderAccount: "Счет получателя",
			textField3: "МФО отправителя",
			receiverMFO: "МФО получателя",
			textField4: "ИНН отправителя",
			receiverINN: "ИНН получателя",
			checkboxesTitle: "Перевести через АНОР",
			checkboxesText: "Центр расчетов ЦБ обычно работает до 17:00 в будни. После 17:00 рекомендуем пользоваться переводами через АНОР. За переводы через АНОР взимается дополнительная комиссия в соответствии с тарифами Банка",
			checkboxesTextDisabled: "Перевод через АНОР доступен только для межбанковских переводов"
		},
		recipient: {
			title: "Получатель",
			textField1: "Наименование получателя",
			clientName: "Наименование клиента",
			textField2: "Номер счета получателя",
			textField3: "ИНН",
			textField4: "Номер лицевого счета получателя",
			type: "Выберите тип получателя",
			corpCard: "Корпоративная карта",
			dividends: "Дивиденды",
			other: "Прочие",
			cardNotFound: "Карта не найдена",
			innField: 'Введите ИНН получателя',
			cardPhisFaces: 'Карта физ. лица',
			defaultText: 'Пополнение корпоративной карты'
		},
		other: {
			textField1: "Сумма документа",
			textField2: "Код назначения",
			textField3: "Детали платежа",
			textField4: "Лицевой счёт",
			textField4LabelDialog: "Поиск лицевого счета организации"
		},
		btn: {
			first: "Подписать и отправить",
			first2: "Ввести",
			first3: "Утвердить",
			first4: "Утвердить и отправить",
			second: "Сохранить черновик",
			third: "Сохранить шаблон",
			reject: "Отклонить"
		},
		payment: {
			title1: "Физические лица",
			title2: "Импорт",
			title3: "Погашение по займу",
			title4: "Дивиденды",
			title5: "Внутри РУз",
			title6: "Прочие",
			title7: "Возврат по экспорту",
			title8: "Переброска"
		},
		errorMessage: "Нельзя пополнять корпоративные карты, принадлежащие другому юридическому лицу или индивидуальному предпринимателю",
		paymentAmount: "Сумма платежа",
		bankCommission: "Комиссия банка",
		additionalPay: "Дополнительные детали платежа",
		dialogSuccess: {
			title: "Отправлено на обработку в банк",
			user: "Ваш платеж на сумму {0} {1} от {2} успешно отправлен бухгалтеру.",
			bux: "Ваш платеж на сумму {0} {1} от {2} успешно отправлен директору.",
			director: "Подписанно",
			templates: "Сохранено в шаблоны",
			recipient: "О статусе платежа пожалуйста следите в уведомлениях или в разделе \"Истории\"",
			recipient3: "О статусе платежа следите в уведомлениях или в разделе \"Истории\"",
			checkStatusLater: "Платеж обрабатывается. Пожалуйста, проверьте статус позже",
			recipientAnor: 'Переводы через АНОР обрабатываются Банком не дольше 10 минут. Результат обработки перевода отобразиться в разделе \"Истории\"',
			drafts: "Сохранено в черновики",
			successfullySent: "Успешно отправлено",
			payrollBux: 'Ваша зарплатная ведомость на сумму {0} {1} от {2} успешно отправлена директору.',
			payrollEmployee: 'Ваша зарплатная ведомость на сумму {0} {1} от {2} успешно отправлена бухгалтеру.',
			btn: 'Ок',
			subTitle: 'Отправлено в банк',
			recipient2: "Если операция попадет на закрытый операционный день, она будет обработана на следующий рабочий день. Мы уведомим, когда операция будет обработана.",
		},
		dialogSuccessTitle: 'Платежное поручение успешно отправлен в банк',
		dialogErrorTitle: 'Произошла ошибка при совершение операции',
		dialogPendingTitle: 'Платежное поручение в режиме ожидание',
		cardAccount: "Номер карточного счета",
		cardAccountReceiver: "Счет карты получателя",
		transitAccount: "Транзитный счет",
		numbers: "цифр",
		isAnorInfoText: "Для перевода через АНОР необходимо отредактировать платеж и указать ИНН получателя",
		cardErrorMessage: 'Карта не активна или карты с таким номером не существует. Проверьте, что номер карты был введен верно',
		cardNotSupported: 'Данный тип карты не поддерживается',
		error: {
			corpCard: 'Вы ввели номер корпоративной карты. Хотите ее пополнить?',
			individualCard: 'Вы ввели номер карты физического лица. Хотите ее пополнить?',
			numberAccountRecipient: 'Номер счета отправителя и получателя не принадлежит одному клиенту',
			validSymbols: `Поле может содержать буквы на латинице и символы / - ? : ( ) . , ' +`
		}
	},
	employees: {
		positionEmplyee: "Руководитель",
		btnFirst: "Просмотр роли полномочий",
		btnSecond: "Удалить",
		btnThird: "Заблокировать",
		btnFourth: "Разблокировать",
		modalLock: {
			title: "Заблокировать сотрудника",
			text: "Вы уверены, что хотите временно заблокировать сотрудника?"
		},
		modalUnLock: {
			title: "Разблокировать сотрудника",
			text: "Вы уверены, что хотите разблокировать сотрудника?"
		},
		modalDelete: {
			title: "Удалить сотрудника",
			text: "Вы действительно хотите удалить профиль сотрудника?",
			btnCancel: "Отмена",
			btnClose: "Закрыть"
		},
		assignRole: {
			text: "Доступны все функции, кроме подписания соглашений и отправки платежей, управления ролевой моделью и картами.",
			btnText: "Подробнее в разделе полномочия",
			authority: "Полномочия",
			btnComplete: "Присвоить роль"
		},
		authority: {
			makingPayment: "Проведение платежей",
			saveDraft: "Сохранить в черновик",
			view: "Просмотр",
			getExtract: "Получение выписки",
			createVP: "Создание ВП ведомости",
			downloadStatement: "Загрузить ведомость",
			saveStatement: "Сохранить ведомость (Шаблон)",
			viewRole: "Просмотр ролей\\полномочий",
			lock: "Блокировка/разблокировка",
			delete: "Удаление",
			sendEmployee: "Ввести (без ЭЦП)",
			sendAccountant: "Ввести и утвердить (без ЭЦП)",
			sendDirector: "Ввести и отправить (ЭЦП обязательно)",
			sendAccountantPayroll: 'Утвердить (без ЭЦП)',
			paymentVisibility: "Видимость платежей"
		}
	},
	currentDate: "Сегодня",
	drafts: {
		header: "Черновики",
		deleteDrafts: "Удалить черновики",
		deleteDraft: "Удалить черновик",
	},
	electCommerce: {
		header: "Электронная коммерция",
		checkNumber: "Номер чека",
		approved: "Проведен",
		declined: "Отклонен",
		paymentDate: "Дата и время платежа:",
		paymentPoint: "Точка оплаты",
		paymentSender: "Отправитель платежа",
		paymentName: "Наименование платежа",
		senderCardNumber: "Номер карты отправителя",
		comment: "Детали платежа",
		payDate: "Дата проводки",
		name: "Наименование",
		serviceId: 'Идентификатор сервиса',
		categoryId: 'Идентификатор категории сервиса',
		serviceName: 'Наименование сервиса',
		payTime: 'Время проведенного платежа',
		subscriber: 'Подписчик',
		amount: 'Сумма трансфера',
		commission: 'Коммиссия',
		systemCommission: 'Комиссия системы',
	},
	nameTemplate: "Назовите шаблон",
	savedInTemplates: "Сохранено в шаблоны",
	payroll: {
		createNewTitle: 'Создайте, загрузите ведомость или скачайте шаблон',
		title: "Выберите платежную систему для начисления зарплаты",
		titleMin: "Выберите платежную систему",
		text: "Для оформления выплаты заработной платы добавьте сотрудника в список и введите сумму. Или загрузите ведомость.",
		btnSelect: "Выбрать получателя",
		btnAdd: "Добавить ведомость",
		totalSum: "Общая сумма",
		paymentRecipient: "Получателей выплаты",
		employee: "сотрудник",
		employee1: "сотрудника",
		employee2: "сотрудников",
		btnAddEmployee: "Добавить сотрудника",
		btnDeleteEmployee: "Удаление сотрудника",
		btnDeleteEmployeeText: "Вы уверены, что хотите удалить сотрудника из списка ведомости?",
		btnSend: "Отправить в банк",
		btnUzcard: "Выплата по UZCARD",
		btnHumo: "Выплата по HUMO",
		createNewPayroll: {
			title: "Создать зарплатную ведомость",
			text: "Выберите сотрудников из списка и укажите заработную плату по каждому"
		},
		downloadPayroll: {
			title: "Зарплатная ведомость",
			blueText: "Выберите",
			text: " или перетяните сюда файл xls, xlsx объемом не более 20 МБ. До отправки в банк Вы можете его редактировать, добавлять и удалять сотрудников.",
			textUpdate: 'Перенесите файл в эту область',
			textUpdate2: 'Файл xls, xlsx размером до 20 Мб',
		},
		addTemplate: {
			title: "Добавить из шаблона",
			text: "Выберите необходимый шаблон из сохраненных раннее"
		},
		createDownloadTemplate: {
			title: "Скачать шаблон зарплатной ведомости",
			text: "Сформируем ведомость из ваших черновиков"
		},
		newPayroll: {
			yearOfLoading: 'Год загрузки',
			textAll: 'Все',
			employees: 'сотрудников',
			swiftBankCode: 'SWIFT - код банка',
			withdrawalAccountNumber: 'Номер счета списания',
			enrollmentАccountNumber: 'Номер счета зачисления',
			applicationNumber: 'Номер заявки',
			currency: "Валюта",
			resetFilter: 'Сбросить фильтр',
			paymentDetails: 'Детали платежа',
			docDate: 'Дата документа',
			docNumber: "Номер документа",
			sheetID: "ID ведомости",
			transitPayrollAccount: "Транзитный зарплатный счёт",
			withdrawalAccount: "Счёт списания",
			header: "Создание новой ведомости",
			title: "Изменение получателя",
			name: "ФИО получателя",
			nameUser: "ФИО сотрудника",
			score: "Счёт получателя",
			scoreStatement: "Счёт клиента",
			embossedName: "Эмбоссированное имя получателя",
			pay: "К выплате",
			select: "Выбрать из справочника",
			btnDownload: "Скачать ведомость",
			requestDelete: "Выход из создания зарплатной ведомости",
			textDelete: "Если вы выйдите из создания зарплатной ведомости, все изменения будут утрачены",
			goOut: "Выйти",
			stay: "Остаться",
			sendToBank: "Отправить в банк",
			saveTemplates: "Сохранить в шаблоны",
			numberStatement: "№ ведомости",
			status: "Состояние",
			dateDownload: "Дата загрузки",
			purposePay: "Назначение платежа",
			exportStatement: "Экспортировать ведомость",
			amountPaid: "Сумма к выплате",
			amountSelect: "Сумма выбранных получателей",
			paymentSystem: "Платежная система",
			noSelect: "Не выбрано",
			searchFamilyAndAccount: 'ФИО или счет сотрудника',
			btnScroll: 'Перейти к оформлению',
			copied: 'Скопировано',
			notCopied: 'Не скопировано',
			withdrawCheckBox: 'Для снятия чек-бокса удалите сумму',
		},
		modalAttention: {
			error: "Ошибка",
			title: "У вас уже есть черновик зарплатной ведомости",
			text: "Если вы продолжите загрузку, то данные черновика будут утеряны",
			btnUpdate: "Перейти к черновику",
			btn: "Продолжить"
		}
	},
	search: "Поиск",
	currencyRates: {
		header: "Курсы валют",
		tabsList: {
			first: "ЦБ",
			second: "Курс УзРВБ",
			third: "Обменный пункт"
		},
		currency: "Валюта",
		course: "Курс",
		buy: "Покупка",
		sell: "Продажа",
		change: "Изменение",
		listCurrency: {
			USD: "Доллар США",
			UZS: "Сум",
			EUR: "Евро",
			GBP: "Фунт стерлингов",
			RUB: "Российский рубль",
			JPY: "Иена",
			QAR: "Катарский риал",
			KGS: "Киргизский сом",
			IRR: "Иранский риал",
			CHF: "Швейцарский франк",
			UAH: "Гривна",
			TMT: "Новый туркменский манат",
			TRY: "Турецкая лира",
			TJS: "Сомони",
			THB: "Бат",
			SGD: "Сингапурский доллар",
			XDR: "СДР",
			SAR: "Саудовский риял",
			PKR: "Пакистанская рупия",
			AZN: "Азербайджанский манат",
			MNT: "Монгольский тугpик",
			MYR: "Малайзийский ринггит",
			KRW: "Вона Республики Корея",
			CAD: "Канадский доллар",
			ILS: "Новый израильский шекель",
			IDR: "Рупия",
			GEL: "Грузинский лари",
			VND: "Донг",
			BND: "Брунейский доллар",
			BRL: "Бразильский реал",
			BYN: "Белорусский рубль",
			BHD: "Бахрейнский динар",
			AED: "Дирхам ОАЭ",
			AFN: "Афгани",
			AMD: "Армянский драм",
			AUD: "Австралийский доллар",
			CNY: "Юань",
			KWD: "Кувейтский динар",
			KZT: "Казахстанский тенге",
			INR: "Индийская рупия",
			HKD: "Гонгконгский доллар",
			MMK: "MMK",
			KHR: "KHR",
			CUP: "CUP",
			CZK: "CZK",
			DKK: "DKK",
			HUF: "HUF",
			ISK: "ISK",
			IQD: "IQD",
			JOD: "JOD",
			LAK: "LAK",
			LBP: "LBP",
			LYD: "LYD",
			MXN: "MXN",
			MDL: "MDL",
			MAD: "MAD",
			OMR: "OMR",
			NZD: "NZD",
			NOK: "NOK",
			PHP: "PHP",
			ZAF: "ZAF",
			SEK: "SEK",
			SYP: "SYP",
			TND: "TND",
			EGP: "EGP",
			UYU: "UYU",
			YER: "YER",
			VEF: "VEF",
			SDG: "SDG",
			RSD: "RSD",
			RON: "RON",
			BYR: "BYR",
			BGN: "BGN",
			PLN: "PLN",
			DZD: "DZD",
			ARS: "ARS",
			BDT: "BDT"
		}
	},
	transfersВyАccountNumber: {
		title: "Переводы по счетам",
	},
	payrollTab: {
		title: "Зарплатные ведомости",
	},
	swiftTransfers: {
		title: "SWIFT-переводы",
	},
	currencyOperations: {
		title: 'Валютно-обменные операции'
	},
	counterparties: {
		positionCounter: "Иностранный",
		btnAdd: "Создать платёж",
		btnHistory: "История операций",
		btnChange: "Изменить",
		title: "Реквизиты",
		name: "Официальное наименование контрагента",
		typeActive: "Вид деятельности",
		country: "Страна",
		titleCall: "Контакты для связи",
		number: "Номер телефона для связи",
		email: "Электронная почта",
		internal: "Внутренние",
		foreign: "Иностранные",
		addCounterparties: {
			header: "Новый контрагент",
			type: "Тип контрагента",
			internal: "Внутренний",
			foreign: "Иностранный",
			name: "Название контрагента",
			bank: "Банк",
			swift: "SWIFT - код",
			swiftBank: "SWIFT - код банка посредника",
			recipientSwiftBank: "SWIFT - код банка контрагента",
			additionalInfo: "Дополнительная информация",
			counterContract: "Страна контрагента",
			save: "Сохранить контрагента",
			inn: "ИНН контрагента",
			mfoBank: "МФО банка контрагента",
			nameText: "Название",
			modal: {
				title: "Отмена действия",
				textCreate: "Вы действительно хотите отменить создание контрагента?",
				textEdit: "Вы действительно хотите отменить изменение контрагента?",
				textPayment: "Вы действительно хотите отменить платеж?",
				complete: "Да",
				not: 'Нет'
			}
		},
		modalDelete: {
			title: "Удаление контрагента",
			text: "Вы действительно хотите удалить контрагента?"
		}
	},
	cardIndex: {
		header: "Картотека",
		docNumber: "Номер документа",
		organDebt: "Организация, выставившая долг",
		remainingSum: "Остаточная сумма",
		initSum: "Начальная сумма",
		totalDebt: "Общая сумма задолженности:"
	},
	sendingSwift: {
		header: "Отправка SWIFT",
		typeTransaction: "Тип операции",
		typeMessage: "Вид сообщения",
		senderBank: "Банк отправителя",
		senderCountry: "Страна отправителя",
		selectBox: "Выберите поле А/D",
		accountBank: "Счет в банке посредника",
		beneficiaryBank: "Банк получателя",
		beneficiaryBankName: "Наименование банка получателя",
		senderBankName: "Наименование банка отправителя",
		beneficiaryCountry: "Страна банка получателя",
		beneficiaryBikBank: "БИК банка получателя",
		beneficiaryKorAccountBank: "Кор.счет в Центральном банке РФ",
		interBank: "Банк посредника",
		interBankName: "Наименование банка посредника",
		interBankCountry: "Страна банка посредника",
		interBikBank: "БИК банка посредника",
		interKorAccountBank: "Кор. счет в ЦБ РФ банка посредника",
		interInn: "ИНН получателя",
		clientINN: "ИНН отправителя",
		interKpp: "КПП получателя",
		interMfo: "МФО отправителя",
		codeOperation: "Код операции",
		nameOperation: "Наименование операции",
		selectOptions: "Выбор опций",
		idn: "ИДН контракта",
		address: "Адрес",
		city: "Город",
		msg: "Укажите наименование цели оплаты (товара или услуги), номер и дату контракта. Если текст не помещается Вы можете продолжить в поле 'Дополнительные детали платежа'",
		nds: "С НДС",
		dontNds: "Без НДС",
		field: "Поле",
		number: "Номер",
		typeContract: "Тип контракта",
		notFoundReferenceBook: "В справочнике кодов не найдено",
	},
	reports: {
		header: "Отчеты",
		reportType: "Вид отчета",
		date: "Дата",
		sort: "Сортировка",
		btnReset: "Сбросить",
		terminalNumbers: "Номера терминала",
		paymentSystem: "Выберите платежной системы",
		selectByTerminal: "Выбрать по терминалу",
		selectByAllTerminals: "Выбрать по всем терминалам",
		selectBySpecificTerminal: "Выбрать по конкретному терминалу",
		terminalReports: "Отчеты по терминалам (xlsx)",
		paymentSystemErrorText: "Извините, у вас не найдено терминалов",
		type: {
			text1: "Выписка по счету на дату (excel)",
			text2: "Платежные документы за период (excel)",
			text3: "Выписка по счету за период (excel)",
			text4: "Ведомость проведенных документов за период (excel)",
			text5: "Справка о работе счета за период (excel)",
			text6: "Сальдово-оборотная ведомость за период (excel)",
			text7: "Ведомость картотеки на дату (excel)",
			text8: "Выписка лицевых счетов за период (excel)",
			text9: "Выписка лицевых счетов за период расширенная (excel)"
		},
		sorts: {
			number: "По номеру документа",
			credit: "По кредитовым оборотам",
			debit: "По дебетовым оборотам"
		},
		turnovers: {
			title: 'Обороты',
			all: 'Все',
			debit: 'Дебет',
			credit: 'Кредит'
		}
	},
	selectAll: "Выбрать все",
	transactHistory: {
		header: "Выписка",
		format: "Формат файла",
		period: "Период",
		selectPeriod: "Выбрать период",
		upload: "Выгрузить",
		outbox: "Исходящие",
		filters: "Фильтры",
		account: "Счет",
		selectAccount: "Выберите счет",
		year: "Год",
		month: "Месяц",
		months: "Месяцев",
		months4: "Месяца",
		week: "Неделя",
		yesterday: "Вчера",
		day: "День",
		hour: "Час",
		status: "Статус",
		approval: "на утверждение",
		cancel: "отменено",
		btnApply: "Применить",
		btnReset: "Сбросить все",
		replenishment: "Пополнение",
		write: "Списание",
		payOrder: "Номер платежного поручения",
		receipt: "Квитанция",
		getReceipt: "Получить выписку",
		repeat: "Повторить",
		templates: "В шаблоны",
		addTemplates: "Добавить в шаблон",
		nameCompany: "Название компании",
		paymentStatuses: {
			text1: "Не определен",
			text2: "Введен",
			text3: "Утвержден",
			text4: "Проведен",
			text5: "Удален",
			text6: "Забракован",
			text7: "Отбракован",
			text8: "Отложен",
			text9: "Отправлен в ТЦР",
			text10: "Отправлен в ГО",
			text11: "Обработка Банком",
			text12: "Подпись не верна",
			text13: "Отправлен на доработку",
			text14: "Отправляется в Банк",
			DELETED_BY_ACCOUNTANT: "Отменен",
			ON_ACCOUNTANT_LIST: "На утверждении",
			ON_PROCESSING_LIST: "В ожидании",
			BANK_TREATMENT: "Отправлен в Банк",
			CANCELLED_BY_ACCOUNTANT: 'Отменен бухгалтером',
			CANCELLED_BY_DIRECTOR: 'Отменен директором',
			partiallyApproved: 'Частично проведен',
			unsent: 'Не отправлен',
			DRAFT: 'Черновик',
			UNDEFINED: 'Не определен',
			REJECTED_TCR: 'Забракован ТЦР',
		},
		client: "клиента",
		debitAccount: "Дебет счет плательщика",
		amount: "Сумма",
		recipientCreditAccount: "Кредит счет получателя",
		amountWords: "Сумма прописью",
		bankCode: "Код банка",
		recipientBankCode: "Код банка получателя",
		done: "Изг.",
		nameDoc: "Наименование документа",
		respondingClerk: "Ответисполнитель",
		namePayers: "Наименование плательщика"
	},
	moduleCredit: {
		header: "Модульный кредит",
		title: "Получите кредит на любые цели быстро и легко",
		btn: "Оформить заявку",
		titleCondition: "Условия кредита",
		creditSize: "Размер кредита",
		rate: "Годовая ставка",
		creditPeriod: "Срок кредита",
		termReceipt: "Срок получения",
		security: "Обеспечение",
		text: "Средства будут направлены на расчётный счет клиента",
		checkboxText1: "Я согласен с условиями",
		checkboxText2: "Публичной Оферты",
		desiredCredit: "Желаемый кредитный лимит",
		confirmCredit: "Подтвердите условия кредита",
		btnClose: "Не подтверждаю",
		btnGood: "Подтверждаю",
		creditApproved: {
			text: "Вам одобрен кредит на следующих условиях:",
			approvedMount: "Одобренная сумма:",
			duration: "Срок",
			interestRate: "Процентная ставка:",
			confirmText: "Для согласия и дальнейшего оформления, Вам необходимо подтвердить заявку до {0}",
			btnDeny: "Отказаться",
			btnConfirm: "Подтвердить"
		},
		unfortunately: {
			text: "К сожалению, сервис Модульного кредита для Вас не доступен.",
			otherText: "Для получения Модульного кредита Вам необходимо открыть первичный счет в АКБ «INfinBank»",
			btn: "На главную",
			notScoring: "К сожалению, Вы не прошли проверку скоринга, в с связи с чем сервис Модульного кредита для Вас недоступен.",
			notScoringInfo: "Вы можете обратиться в любой филиал АКБ «InfinBank» за получением кредита в установленном порядке."
		},
		inProgress: {
			text: "Ваша заявка на получения модульного кредита находится в обработке. Ожидайте ответа посредством уведомления в приложении, в ближайшее время Ваша заявка будет рассмотрена."
		},
		settings: {
			loanAmount: "от 25 млн. до 1 млрд.",
			annualRate: "22,99%",
			creditTerm: "90 дней",
			loanTerm: "от 1 до 2 дней",
			security: "Не требуется"
		},
		days: "{0} дней",
		enrollment: "Зачисление",
		status: {
			PENDING: "Ваша заявка на получение модульного кредита находится в обработке. Ожидайте ответа, в ближайшее время она будет рассмотрена, ответ Вы получите уведомлением в приложении.",
			UNAVAILABLE: [
				"К сожалению сервис Модульного кредита для Вас не доступен.",
				"Для получения Модульного кредита Вам необходимо открыть первичный счет в АКБ \"InfinBANK\""
			],
			REJECTED: [
				"К сожалению вы не прошли проверку скоринга, с связи с чем сервис Модульного кредита для Вас недоступен. Вы можете подать заявку через {0} дней",
				"Вы можете обратиться в любой филиал АКБ \"InfinBANK\" за получением кредита в установленном порядке."
			],
			TO_SUPPORT: "При обработке вашей заявки возникла ошибка.<br>Просим обратиться в контакт центр по номеру телефона +998 (71) 202-50-80",
			END_TERM_SLA: "Жизненный срок Вашей заявки на получение модульного кредита истек",
			CANCELLED: "Вы отказались от получения модульного кредита.",
			K2_APPROVED_RESULT: "При повторной проверке статуса Картотека 2 у Вас не обнаружено задолженности и Ваша заявка отправлена на зачисления средств на расчётный счёт. Просим подождать.",
			WAITING_FOR_K2_CHECK: "Осуществляется проверка наличия задолженности по Картотеке 2. Ожидайте ответа.",
			WAITING_FOR_LIMIT: "Ваша заявка отправлена на зачисление средств на расчётный счёт. Просим подождать.",
			COMPLETED: "Ваши средства успешно зачислены на ваш расчётный счёт",
			WAITING_FOR_K2: [
				"Для проверки статуса задолженности по Картотеке 2 нажмите кнопку повторная проверка К2",
				"Повторная проверка Картотеки 2"
			],
			K2_DETECTED: [
				"На текущую дату у Вас имеется задолженность  на сумму {0} сум по Картотеке 2.",
				"При нажатии кнопки подтвердить кредитные средства будет зачислены на Ваш счёт.",
				"При нажатие кнопки Отменить банк будет ожидать полного погашения картотеки для последующей выдачи кредита",
				"Вам необходимо принять решение до {0}."
			]
		}
	},
	notification: {
		header: "Уведомления!",
		news: "Новости",
		history: "История входов",
		btnDetails: "Подробности",
		operation: 'Операции',
		newsAndOffers: 'Новости и предложения'
	},
	publicOffer: {
		header: "Публичная оферта",
		text: "Настоящая оферта разработана в целях заключения договора между Акционерно-коммерческим банком «Invest Finance Bank» с участием иностранного капитала (далее – Банк) с одной стороны, и юридическим лицом или индивидуальным предпринимателем – получателем модульного кредита (бизнес овердрафта) (далее – Кредит) посредством системы дистанционного банковского обслуживания (ДБО) (далее – Заемщик) с другой стороны.",
		titleAkb: 'Публичная оферта АКБ “InfinBANK”',
		instruction: 'Инструкция пользователя'
	},
	saleCurrency: {
		header: "Продажа валюты",
		selectCur: "Выберите валюту",
		senderNumber: "Номер счета отправителя",
		requestAmount: "Сумма заявки",
		minRate: "Минимальный курс",
		btbSend: "Отправить"
	},
	setting: {
		title: "Наименование компании",
		main: "Основные",
		security: "Безопасность",
		other: "Другое",
		lang: "Язык",
		save: "Сохранить",
		offer: "Оферта",
		header: "Настройка безопасности",
		change: "Изменить пароль",
		current: "Текущий пароль",
		new: "Новый пароль",
		confirmNew: "Подтвердите новый пароль",
		changePasswordGoToBranch: "Вы ввели неверный пароль более 10 раз. Для смены пароля просим Вас обратиться в отделение банка с документом, удостоверяющим личность",
		passwordIsntEqual: "Пароли не совпадают, повторите попытку",
		incorrectPassword: "Неверный пароль",
		incorrectPasswordValidate: "Пароль должен состоять из 8 символов на латинице, содержать цифры, не менее 1 большой буквы, не менее 1 маленькой буквы.",
		password: {
			title: "Пароль должен содержать:",
			min: "общее количество символов - 8",
			number: "наличие цифр",
			letter: "наличие букв на латинице",
			minUpperLetter: "наличие как минимум 1 буквы с верхним регистром",
			minLowerLetter: "наличие как минимум 1 буквы с нижним регистром",
			other: "Будьте бдительны, никому не сообщайте пароль."
		},
		activeSession: {
			title: "Активные сессии",
			current: "Текущая сессия",
			completeSessions: "Завершить остальные сессии",
			online: "В сети",
			textChange: "Для завершения сессии нажмите верхнюю кнопку “Изменить”",
			complete: "Готово"
		}
	},
	services: {
		url2: "Просмотр картотеки",
		title1: "Кредиты",
		title2: "Депозиты"
	},
	support: {
		header: "Поддержка",
		title: "Здравствуйте, чем Вам помочь?",
		telegram: "Задать вопрос в Telegram bot",
		openTelegram: "Открыть приложение",
		phone: "Позвонить",
		social: "Социальные сети"
	},
	draft: {
		header: "Черновик",
		changeStatus: "Изменение статуса:",
		edit: "Редактировать",
		paymentRecipient: "Получатель платежа",
		recipientBy: "Кто получил",
		mfo: "МФО филиала",
		title1: "Сумовые",
		title2: "Валютные",
		payment: "платеж"
	},
	approval: {
		idDoc: "ID документа",
		paymentCommission: "Комиссии",
		selectPayments: "Выберите платежи для подписи",
		signAll: "Утвердить все",
		sign: "На подпись",
		sign2: "Подписать"
	},
	emptyStatuses: {
		header: "Список пуст",
		text: "Нет информации по вашему запросу",
		emptyTransactions: 'За указанный период операций нет'
	},
	role: {
		employee: "Сотрудник",
		accountant: "Бухгалтер",
		director: "Директор"
	},
	roleInfo: {
		employee: "Сотрудник имеет право на просмотр и ввод  платёжных и иных документов, без возможности отправки в Банк на исполнение платежных документов.",
		accountant: "Бухгалтер имеет право на ввод, на отправку на подпись Директору и на просмотр платёжных и иных документов, а также на получение различной отчетности, но без возможности отправки в Банк на исполнение платежных документов.",
		director: "Директор имеет полный доступ к ДБО, включая просмотр, ввод и отправку в Банк платежных документов и иных документов. "
	},
	weekDays: {
		1: "пн",
		2: "вт",
		3: "ср",
		4: "чт",
		5: "пт",
		6: "сб",
		7: "вс"
	},
	choose: "Выбрать",
	common: {
		attention: "Внимание"
	},
	number: [
		[ "один", "одна", "Ноль" ],
		[ "два", "две" ],
		[ "три" ],
		[ "четыре" ],
		[ "пять" ],
		[ "шесть" ],
		[ "семь" ],
		[ "восемь" ],
		[ "девять" ],
		[ "десять" ],
		[ "одиннадцать" ],
		[ "двенадцать" ],
		[ "тринадцать" ],
		[ "четырнадцать" ],
		[ "пятнадцать" ],
		[ "шестнадцать" ],
		[ "семнадцать" ],
		[ "восемнадцать" ],
		[ "девятнадцать" ],
		[ "двадцать" ],
		[ "тридцать" ],
		[ "сорок" ],
		[ "пятьдесят" ],
		[ "шестьдесят" ],
		[ "семьдесят" ],
		[ "восемьдесят" ],
		[ "девяносто" ],
		[ "сто" ],
		[ "двести" ],
		[ "триста" ],
		[ "четыреста" ],
		[ "пятьсот" ],
		[ "шестьсот" ],
		[ "семьсот" ],
		[ "восемьсот" ],
		[ "девятьсот" ],
		[ "тысяч" ],
		[ "тысяча" ],
		[ "тысячи" ],
		[ "миллионов" ],
		[ "миллион" ],
		[ "миллиона" ],
		[ "миллиардов" ],
		[ "миллиард" ],
		[ "миллиарда" ],
		[ "триллионов" ],
		[ "триллион" ],
		[ "триллиона" ]
	],
	currency: {
		cent: {
			RUB: [ "копеек", "копейка", "копейки" ],
			USD: [ "центов", "цент", "цента" ],
			EUR: [ "евроцентов", "евроцент", "евроцента" ],
			UZS: [ "тийинов", "тийин", "тийинов" ]
		},
		self: {
			RUB: [ "рублей", "рубль", "рубля" ],
			USD: [ "долларов США", "доллар США", "доллара США" ],
			EUR: [ "евро", "евро", "евро" ],
			UZS: [ "сумов", "сум", "сум", 'сума' ]
		}
	},
	month: [
		[ "января" ],
		[ "февраля" ],
		[ "марта" ],
		[ "апреля" ],
		[ "мая" ],
		[ "июня" ],
		[ "июля" ],
		[ "августа" ],
		[ "сентября" ],
		[ "октября" ],
		[ "ноября" ],
		[ "декабря" ]
	],
	date: {
		yearShort: "г."
	},
	validate: {
		numberCard: "Можно пополнять только карты своей компании. Проверьте номер счета получателя"
	},
	emptyBlock: {
		accounts: {
			title: "У вас нет счетов",
			text: "Для выбора счета сначала необходимо подать заявку на его оформление"
		},
		cards: {
			title: "У Вас нет корпоративных карт",
			text: "Для выбора карт необходимо подать заявку на выпуск"
		},
		companyAccounts: {
			title: "Выберите один из продуктов",
			text: "Здесь будут отображаться детали вашей карты, счета, кредита или депозита, выберите один изпродуктов для просмотра информации"
		},
		later: {
			title: "Попробуйте позже",
			text: "Идет процесс закрытия операционного дня."
		},
		contragent: {
			title: "Список контрагентов пуст",
			text: "Доп текст"
		},
		contragent2: {
			title: "Добавьте контрагента",
			text: "После добавления контагента, выберите его из списка слева, вся подробная информация отобразится здесь."
		},
		employees: {
			title: "Выберите одного из сотрудников",
			text: "Здесь будут отображаться детали вашего сотрудника, выберите одного из сотрудников для просмотра информации"
		}
	},
	form: {
		fill: "Пожалуйста, заполните данное поле",
		payrollPurpose: 'Введите не менее {0} символов в поле "Детали платежа", Вы ввели {1}'
	},
	modalTemplate: {
		title: "Введите название",
		deleteTitle: "Удаление шаблона",
		deleteText: "Вы уверены, что хотите удалить шаблон"
	},
	statuses: {
		titleDeleteDraft: "Выберите черновик для удаление",
		textSelected: "Удалить выбранные"
	},
	eimzo: {
		titleSelected: "Выберите ключ",
		errorCAPIWS: "Ошибка соединения с E-IMZO. Возможно у вас не установлен модуль E-IMZO или Браузер E-IMZO.",
		errorBrowserWS: "Браузер не поддерживает технологию WebSocket. Установите последнюю версию браузера.",
		errorUpdateApp: "ВНИМАНИЕ !!! Установите новую версию приложения E-IMZO или Браузера E-IMZO.",
		errorDownloadEimzo: "Скачать ПО E-IMZO",
		errorDownloaded: "Загрузка",
		errorWrongPassword: "Пароль неверный"
	},
	crk: {
		titleModal: 'УЦ ЭЦП',
		titleSelected: 'Выберите ключ',
		deadline: 'Срок',
		expired: 'истек',
		errorWrongPassword: 'Пароль неверный',
		errorCrk: 'Не удалось установить подключение к УЦ ЭЦП',
		errorKeyCrk: 'Ключ не найден!',
		errorApp: 'Модуль УЦ ЭЦП не подключен. Установите модуль.',
		errorConfirmCrk: 'Произошла ошибка при подписание в УЦ ЭЦП',
		errorDefault: 'При проверки ЭЦП возникла ошибка. Повторите операцию позже или обратитесь в Банк.',
		errorKeyNotFound: 'ЭЦП ключ не обнаружен. Проверьте подключение USB ключа к компьютеру.',
		downloadModule: 'Скачать модуль'
	},
	forex: {
		countryName: 'Наименование страны',
		title: 'Валютные операции',
		buyCurrency: 'Покупка валюты',
		sellCurrency: 'Продажа валюты',
		create: 'Создать заявку',
		appWillLost: 'Данные по заявке будут потеряны',
		appAndFilesWillLost: 'Данные по заявке и вложенные файлы будут потеряны',
		replaceFilePrevent: 'Только один файл может быть приложен к заявке',
		replace: 'Заменить',
		uz: 'Узбекистан',
		day: 'Дата заявки',
		buy: 'Покупка',
		sell: 'Продажа',
		sendToAccountant: 'Ваша заявка на сумму {0} от {1} успешно отправлена бухгалтеру',
		sendToDirector: 'Ваша заявка на сумму {0} от {1} успешно отправлена директору',
		sendToBank: 'Ваша заявка на сумму {0} от {1} успешно отправлена в банк',
		saveUpdates: 'Сохранить изменения',
		confirmDeleteDraft: 'Вы хотите удалить черновик?',
		enterTemplateName: 'Введите название шаблона',
		existTemplateName: 'Шаблон с указанным именем уже существует',
		templateName: 'Название шаблона',
		deleteTemplate: 'Удалить шаблон',
		confirmDeleteTemplate: 'Вы хотите удалить шаблон?',
		applicationNumber: '№ заявки',
		enterApplicationNumber: 'Введите № заявки',
		status: {
			ON_ACCOUNTANT_LIST: 'На утверждении у бухгалтера',
			ON_DIRECTOR_LIST: 'На утверждении у директора',
			DELETED_BY_ACCOUNTANT: 'Удалено бухгалтером',
			DELETED_BY_DIRECTOR: 'Удалено директором',
			ON_PROCESSING_LIST: 'В ожидании',
			INTRODUCED: 'Введен',
			BANK_REVIEW: 'На рассмотрении в банке',
			CONFIRMED: 'Подтвержден',
			CONDUCTED_GO: 'Проведен в ГО',
			CONDUCTED_BRANCH: 'Проведен в Филиале',
			REJECTED: 'Отклонен',
			DELETED: 'Удален',
			CREATED: 'Создан',
			BANK_TREATMENT: 'Отправлено в банк',
		},
		downloadPdf: 'Скачать в формате (.pdf)',
		toTemplate: 'В шаблоны',
		approvalDelete: {
			deleteOne: 'Вы хотите удалить заявку?',
			deleteFour: 'Вы хотите удалить {0} заявки?',
			deleteFive: 'Вы хотите удалить {0} заявок?',
		},
		confirmAndSend: 'Подтвердить и отправить',
		payments: 'Платежи',
		applications: 'Заявки',
		purpose_CODE_011: '<ol><li>Решение учредителей о распределении прибыли;</li><li>Заключение аудиторской фирмы или налогового органа;</li><li>Расчет средств на конвертацию.</li></ol>',
		purpose_CODE_012: '<ol><li>Копия приказа о командировании;</li><li>Расчет суммы в иностранной валюте;</li><li>Копия решения Кабинета Министров (если имеется).</li></ol>',
		purpose_CODE_014: '<ol><li>Оригинал подтверждения расчетно-клиринговой палаты;</li><li>Копия договора, заключенного между брокером (инвестиционным посредником) и нерезидентом - юридическим лицом на оказание брокерских услуг</li></ol>',
		accountVerifyingError: {
			WRONG_DATE: 'В данное время заявка не может быть отправлена в банк, так как календарная дата не совпадает с банковским днем.',
			RATE_CHANGED: 'Внимание! Курс валюты изменился',
			FUNDS_LACK: 'Недостаточно средств для осуществления операции на сумму {0}',
			CONTRACT_NOT_ACTIVE: 'Срок действия контракта истек. Просим внести изменения',
			FUNDS_LACK_SELL: 'Для совершения операции на сумму {2} {1} на счете списания не хватает {0} {1}.',
		},
		rateChanged: 'Первоначальный курс: {0} UZS<br>Текущий курс: {1} UZS<br>Эквивалент в сумах: {2} UZS',
		openReceiverAccount: 'Для осуществления операции Вам необходимо открыть специальные счета для конвертации',
		refillAccountBySendingPayment: 'Для Вашей заявки не хватает покрытия на сумму {0} UZS. Создать и отправить платеж в банк?',
		paymentOrderDetails: 'Блокировка средств для конвертации по контракту №{0} от {1}',
		paymentOrderOnlyDetails: 'Блокировка средств для конвертации по контракту',
		toFullCompletion: 'До полного исполнения',
		course: 'Курс заявки',
		courseAvailable: 'Курс действителен на текущую дату',
		uzsEquivalent: 'Эквивалент в национальной валюте',
		purpose: 'Цель покупки',
		idnNumber: 'Номер внешнеторгового контракта',
		idnDate: 'Дата контракта',
		idnCountry: 'Страна инопартнера',
		phone: 'Телефон клиента',
		additional: 'Дополнительно',
		serviceType: 'Вид услуги',
		shortPurposeDesc: 'Краткое описание цели',
		account: 'Счет клиента',
		reservingAccount: 'Счет для резервирования',
		loanAccount: 'Счет для погашения кредита',
		receiverAccount: 'Спецсчет в валюте',
		contractEndDate: 'Срок действия контракта',
		partnerName: 'Наименование инопартнера',
		contractAmount: 'Сумма контракта',
		purposeItems: {
			CODE_001: 'Оборудование, комплектующие и запасные части',
			CODE_002: 'Сырьё и материалы',
			CODE_003: 'Услуги',
			CODE_004: 'Кредиты: Гарантированные Правительством',
			CODE_005: 'Кредиты: Не гарантированные Правительством',
			CODE_006: 'Для погашения кредита обслуживающего банка',
			CODE_007: 'Лизинговые платежи',
			CODE_008: 'Медикаменты, лекарства и медицинские изделия',
			CODE_009: 'Легковые автомобили',
			CODE_010: 'Другие товары народного потребления',
			CODE_011: 'Для репатриации доходов иностранных инвесторов',
			CODE_012: 'Командировочные расходы',
			CODE_013: 'Для других целей',
			CODE_014: 'Для перевода средств, полученных от продажи продукции на открытых электронных торгах товарно-сырьевых бирж',
		},
		transactionCode: 'Код транзакции',
		fundsSource: 'Источник средств',
		currencyAccount: 'Валютный счет',
		shortDesc: 'Краткое описание',
		buyTypeItems: {
			TRANSPORTATION: 'Транспортные услуги',
			CONSULTING: 'Консалтинговые услуги',
			ADVERTISING: 'Рекламные услуги',
			REPAIR: 'Ремонтные услуги',
			COMMUNICATION: 'Услуги связи',
			INSURANCE: 'Страховые услуги',
			FINANCIAL: 'Финансовые услуги',
			ROYALTIES: 'Роялти',
			INFORMATION: 'Информационные услуги',
			CONSTRUCTION: 'Строительные услуги',
			OTHER: 'Другие',
		},
		buyForeignCurrency: 'Покупка иностранной валюты',
		sellForeignCurrency: 'Продажа иностранной валюты',
		exchange: 'Обмен СКВ на СКВ',
		foundsSourceItems: {
			EXPORT_EARNINGS: 'Поступления от экспорта',
			LOANS_RECEIVED_FROM_DOMESTIC_BANK: 'Кредиты, полученные от отечественного банка',
			LOANS_FROM_ABROAD: 'Кредиты, поступившие из-за границы',
			REVERSE_SALE_UNUSED_CURRENCY: 'Обратная продажа неиспользованной валюты',
			OTHER_REFERENCES: 'Другие источники',
		},
		amountFrom: 'Сумма от',
		amountTo: 'Сумма до',
		fileUploadRequired: 'Загрузка файла обязательна',
	},
	modals: {
		anor: {
			modalConfirmTitle: "Выберете тип перевода",
			modalConfirmText: "В настоящее время, Центр расчетов ЦБ не принимает запросы на перевод. Вы можете совершить перевод через АНОР. Выберите способ проведения перевода:",
			btnAnor: "Через АНОР",
			btnCB: "Центр расчетов ЦБ",
			btnLater: "Выполнить позже"
		}
	},
	sessionExpired: 'Вы слишком долго не проявляли активность. В целях безопасности произошёл автоматический выход из системы. Для продолжения работы, пожалуйста, повторно осуществите вход.',
	openAccount: {
		enterPhoneNumber: 'Введите номер телефона',
		customerName: 'Укажите как к Вам обращаться',
		getCode: 'Получить код',
		confirmOffer: 'Нажимая «{0}», Вы принимаете и соглашаетесь с условиями <a href="{1}" target="_blank" class="link-primary">оферты</a>',
		inn: 'ИНН юридического лица',
		pinfl: 'ПИНФЛ юридического лица',
		fillApplication: 'Заполните заявку на оформление счёта',
		isIndividualEntrepreneur: 'Является ли ваше предприятие “ИП”?',
		isIndividualEntrepreneurDescription: 'ИП - индивидуальным предпринимателем',
		openSecondaryAccount: 'Вы открываете вторичный счёт',
		companyName: 'Наименования организации',
		registerDate: 'Дата регистрации',
		registerEndDate: 'Дата окончания регистрации',
		companyAddress: 'Адрес организации',
		primaryAccountBank: 'Банк в котором открыт первичный счет',
		yourApplications: 'Ваши заявки',
		status: {
			OPEN: 'Принято Банком',
			DECLINED_BY_BANK: 'Отклонено Банком',
			DECLINED_BY_CUSTOMER: 'Отказ Клиентом',
			ACCOUNT_OPENED: 'Счет открыт',
			DONE: 'Выполнено',
		},
		warnTheClient: 'Ваша заявка на открытие счета принята. Наши сотрудники скоро свяжутся с Вами.',
		documentsNotProvided: 'Предоставлены не все необходимые документы',
		accountType: {
			PRIMARY_ACCOUNT: 'Первичный счет',
			SECONDARY_ACCOUNT: 'Вторичный счет'
		},
		aboutCompany: 'О компании',
		toMainPage: 'На главную сайта',
		legalEntityLoadingHintList: [
			'Ищем Ваши ранее оставленные заявки...',
			'Ищем среди клиентов...',
			'Проверяем информацию в службе Единого окна...',
			'Ищем Ваши счета в других банках...',
			'Сверяем данные...',
			'Осталось совсем немного подождать...',
		],
		organizationName: 'Наименование организации',
		initiatorPhone: 'Номер телефона инициатора заявки',
		innOrPinfl: 'Ваш ИНН/ПИНФЛ',
		applicationNumber: 'Номер заявки',
		applicationDate: 'Дата заявки',
		selectedTariff: 'Выбранный тариф',
		accountTypeTitle: 'Тип счета',
		employeesCount: 'Количество сотрудников с доступом в Интернет-банк',
		branchNumber: 'МФО филиала',
		assignedEmployee: 'Назначен сотрудник',
		meetingAddress: 'Адрес встречи',
		bankEmployeePhone: 'Телефон сотрудника банка',
		meetingDate: 'Дата и время встречи',
		applyApplication: 'Подать заявку',
		application: 'Заявка на открытие счета',
		enterSmsCode: 'Введите код из СМС',
		codeSent: 'Код выслан на номер {0}',
		incorrectInn: 'Юридическое лицо с таким ИНН не существует. Проверьте корректность введенного ИНН',
		changePhone: 'Изменить телефон',
		getNewCode: 'Получить новый код можно через {0}:{1} сек.',
		end: 'Заполнение заявки завершено'
	},
	paymentRequirements: {
		incoming: 'Входящие платежные требования',
		outgoing: 'Исходящие платежные требования',
		familiarize: 'Ознакомиться',
		offer: 'Я подтверждаю, что ознакомился с платежными требованиями в количестве {0} шт., которые в настоящее время выставлены к {1}.<br><br>Я понимаю, что после подтверждения факта того, что я ознакомился со  списком выставленных платежных требований, все платежные требования, которые в настоящее время выставлены к {1}, будут помещены в Картотеку 1.<br><br>Я понимаю, что после помещения требований в Картотеку 1, если я не приму решения об оплате или об отказе в оплате этих требований в течении 5 рабочих дней, то они автоматически будут исполнены или помещены в Картотеку 2 (в случае отсутствия средств на счете для оплаты требования).',
		requestsProcessed: 'Платежные требования успешно обработаны',
		requestsProcessedDetails: 'Из {0} платежных требований успешно обработаны и помещены в Картотеку 1 {1} требований.',
		requestsProcessedHint: 'При переходе в Картотеку ваша текущая операцию будет сохранена в черновиках',
		sign: 'Ознакомление',
		requests: 'Платежные требования',
		request: 'Платежное требование',
		goToCardIndex: 'Перейти к Картотеке {0}',
		incomingShort: 'Входящие',
		outgoingShort: 'Исходящие',
		docDate: 'Дата документа',
		debtType: 'Вид задолженности',
		destCardIndexCode: 'Код назначения картотеки',
		destCode: 'Код назначения платежа',
		toCompany: 'Организация выставившая требование',
		fromCompany: 'Организация, к которой выставили требование',
		pinfl: 'ПИНФЛ',
		unprocessed: 'Необработанные',
		processed: 'Обработанные',
		dueDate: 'Необходимо принять решение до',
		daysLeft: {
			one: 'Остался {0} день',
			fromTwoToFour: 'Осталось {0} дня',
			fromFive: 'Осталось {0} дней',
		},
		denie: 'Отказать',
		pay: 'Оплатить',
		denieTitle: 'Отказ',
		rejectionReason: 'Причина отказа',
		create: 'Создать платежное требование',
		recall: 'Отозвать',
		createShort: 'Создать',
		recallQuestion: 'Отозвать платежное требование?',
		fundRecipient: 'Получатель средств',
		fundSender: 'Отправитель средств',
		withAcceptance: 'С акцептом',
		withoutAcceptance: 'Без акцепта',
	},
	minAmount: 'Минимальная сумма {0}',
	attachments: 'Вложения',
	attachDocument: 'Прикрепите документ',
	minLength: 'Минимальное кол-во символов {0}',
	uploadFiles: 'Загрузить файлы',
	acceptedFileFormats: 'Поддержка форматов: {0}',
	paymentsAndApplications: 'Платежи и заявки',
	hasUpdate: 'Вышло новое обновление',
	update: 'Обновить',
	minAmountOperation: 'Сумма операции не может быть менее {0}',
	innOrPinflInvalid: 'Введите 9 цифр, если получатель ЮЛ, или 14 цифр, если получатель ИП',
	incorrectAccount: 'Введен некорректный номер счета',
	beforeInputMFO: 'Проверить счет не удалось. Введите МФО',
	incorrectAccountOrMfo: 'Введен некорректный номер счета или МФО',
	reference: {
		branch: 'Поиск по номеру МФО и его наименованию',
		code: 'Код',
		codeDescription: 'Описание кода назначения картотеки',
		debtDescription: 'Описание вида задолженности',
		debt: 'Поиск вида задолженности',
		codeCardIndex: 'Поиск кода назначения картотеки',
		purposeCode: 'Поиск кода назначения платежа',
		purposeDescription: 'Описание кода назначения платежа',
	},
	needBankAccount: 'Для оформления исходящего платежного требования, необходимо, чтобы основной счет был открыт в InFinBank',
	startSearch: 'Начните поиск',
	confirmActionWithSms: 'Подтвердите действие с помощью СМС-кода',
	alert: {
		browserError: 'К сожалению, ваш браузер не поддерживается. Возможны проблемы в работе приложения.',
		supportBrowser: 'Поддерживаемые браузеры',
		titleSupportBrowser: 'Поддерживающие браузеры',
		versionOld: 'Версия {0} или более новая'
	},
	revisionError: {
		title: 'Причина возвращения на доработку',
		allAmount: 'Общая сумма задолженности',
		deleteDocumnet: 'Удаление документа',
		deleteQuestion: 'Хотите удалить?'
	}
};
